/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RecurringBillingMode {
  GROW_DIRECT_DEBIT = 'grow_direct_debit',
  TOKEN = 'token',
}
